import React from "react";
import { LargeTranslation, BrandName } from "./styles";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../../redux/brand";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const WelcomeText = ({ brandName, showWelcome, customWelcomeText }) => {
  if (showWelcome) {
    if (customWelcomeText) {
      return (
        <ReactMarkdown
          linkTarget="_blank"
          rehypePlugins={[rehypeRaw]}
        >
          {customWelcomeText}
        </ReactMarkdown>
      );
    } else {
      return (
        <LargeTranslation
          id="signin.signin-welcome-brand"
          brand={<BrandName>{brandName}</BrandName>}
        >
          Welcome to Bookshelf
        </LargeTranslation>
      );
    }
  } else {
    return null;
  }
};

const mapStateToProps = state => ({
  brandName: brandSelectors.getBrandValue(state, "name", "Bookshelf"),
  showWelcome: brandSelectors.getBrandValue(state, "Signin.welcome", true),
  customWelcomeText: brandSelectors.getBrandValue(
    state,
    "Signin.customWelcomeText",
    undefined
  )
});

export default connect(mapStateToProps)(WelcomeText);
